import {
  ActionType,
  IVerifyOTPPayload,
  IVerifyOTPResponse,
} from "models/setting/verifyOTP";

export const verifyOTPAction = (payload: IVerifyOTPPayload) => {
  return {
    type: ActionType.VERIFY_OTP,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.VERIFY_OTP_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IVerifyOTPResponse) => {
  return {
    type: ActionType.VERIFY_OTP_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.VERIFY_OTP_RESET,
  };
};
